import { logout } from '.';
// Perform alternate action if we're on a URL that matches the provided regex filter
// else logout

export function filteredLogout(re, altFallback = () => {}) {
  /* eslint-disable no-unused-expressions */
  re.test(window.location.href) ? altFallback() : logout();
  /* eslint-enable no-unused-expressions */
}



// WEBPACK FOOTER //
// ./src/helpers/filteredLogout.js